/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ControlModification } from './ControlModification';
import {
    ControlModificationFromJSON,
    ControlModificationFromJSONTyped,
    ControlModificationToJSON,
    ControlModificationToJSONTyped,
} from './ControlModification';

/**
 * Profile creation request
 * @export
 * @interface NistCSFProfileCreateRequest
 */
export interface NistCSFProfileCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof NistCSFProfileCreateRequest
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof NistCSFProfileCreateRequest
     */
    version?: string;
    /**
     * 
     * @type {string}
     * @memberof NistCSFProfileCreateRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof NistCSFProfileCreateRequest
     */
    documentId?: string;
    /**
     * 
     * @type {string}
     * @memberof NistCSFProfileCreateRequest
     */
    oscalVersion?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof NistCSFProfileCreateRequest
     */
    selectedControlIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof NistCSFProfileCreateRequest
     */
    excludedControlIds?: Array<string>;
    /**
     * 
     * @type {Array<ControlModification>}
     * @memberof NistCSFProfileCreateRequest
     */
    modifications?: Array<ControlModification>;
}

/**
 * Check if a given object implements the NistCSFProfileCreateRequest interface.
 */
export function instanceOfNistCSFProfileCreateRequest(value: object): value is NistCSFProfileCreateRequest {
    return true;
}

export function NistCSFProfileCreateRequestFromJSON(json: any): NistCSFProfileCreateRequest {
    return NistCSFProfileCreateRequestFromJSONTyped(json, false);
}

export function NistCSFProfileCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): NistCSFProfileCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'version': json['version'] == null ? undefined : json['version'],
        'description': json['description'] == null ? undefined : json['description'],
        'documentId': json['documentId'] == null ? undefined : json['documentId'],
        'oscalVersion': json['oscalVersion'] == null ? undefined : json['oscalVersion'],
        'selectedControlIds': json['selectedControlIds'] == null ? undefined : json['selectedControlIds'],
        'excludedControlIds': json['excludedControlIds'] == null ? undefined : json['excludedControlIds'],
        'modifications': json['modifications'] == null ? undefined : ((json['modifications'] as Array<any>).map(ControlModificationFromJSON)),
    };
}

export function NistCSFProfileCreateRequestToJSON(json: any): NistCSFProfileCreateRequest {
    return NistCSFProfileCreateRequestToJSONTyped(json, false);
}

export function NistCSFProfileCreateRequestToJSONTyped(value?: NistCSFProfileCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'version': value['version'],
        'description': value['description'],
        'documentId': value['documentId'],
        'oscalVersion': value['oscalVersion'],
        'selectedControlIds': value['selectedControlIds'],
        'excludedControlIds': value['excludedControlIds'],
        'modifications': value['modifications'] == null ? undefined : ((value['modifications'] as Array<any>).map(ControlModificationToJSON)),
    };
}

